export enum FILTER_SECTIONS {
  Posts = 'Posts',
  Audiences = 'Audiences',
  AutoManaged = 'Auto Managed',
  PerformanceFilter = 'Performance Filter',
  CampaignInformation = 'Campaign Information',
  InfluencerAttributes = 'Influencer Attributes',
  CampaignPostsDiscovery = 'Campaign Posts Discovery'
}
